import {CONTENT_SUBMISSION_STATUS} from '@/types/contentSubmission';

export const SKIP_REQUEST_EDITS_MESSAGE_INTERCEPT_KEY =
  'awar.skipRequestEditsMessageIntercept';

export function isRequestEditsMessageInterceptSkipped(): boolean {
  try {
    return (
      localStorage.getItem(SKIP_REQUEST_EDITS_MESSAGE_INTERCEPT_KEY) === 'true'
    );
  } catch {
    return false;
  }
}

export function setSkipRequestEditsMessageIntercept(skip: boolean): void {
  try {
    if (skip) {
      localStorage.setItem(SKIP_REQUEST_EDITS_MESSAGE_INTERCEPT_KEY, 'true');
    } else {
      localStorage.removeItem(SKIP_REQUEST_EDITS_MESSAGE_INTERCEPT_KEY);
    }
  } catch {
    // localStorage may be unavailable (private mode / SSR); ignore.
  }
}

export function shouldShowRequestEditsMessageIntercept({
  aasmState,
  isLatestVersion,
}: {
  aasmState?: string | null;
  isLatestVersion: boolean;
}): boolean {
  return (
    aasmState === CONTENT_SUBMISSION_STATUS.PENDING &&
    isLatestVersion &&
    !isRequestEditsMessageInterceptSkipped()
  );
}
